import Input from 'components/Input/Input';
import PasswordInput from 'components/Input/PasswordInput';
import InstructionBox from 'components/Instruction/InstructionBox';
import { InstructionCallout } from 'components/Instruction/InstructionCallout';
import InstructionItem from 'components/Instruction/InstructionItem';
import { AppLink } from 'components/Link/AppLink';
import COLORS from 'constants/colors';
import { useAutoScrollInstructions } from 'hooks/useAutoScrollInstructions';
import styled from 'styled-components';
import MainContainer from '../../SignInMainContainer';

const StyledInstructionBox = styled(InstructionBox)`
  margin-bottom: 12px;
`;

interface CredentialsProps {
  username: {
    value: string;
    invalid: boolean;
    onChange: (value: string, invalid?: boolean) => void;
  };
  password: {
    value: string;
    invalid: boolean;
    onChange: (value: string, invalid?: boolean) => void;
  };
  instructionsLink?: string;
  instructionsInnerHtmlToScroll?: string;
}

const Credentials = ({
  username,
  password,
  instructionsLink,
  instructionsInnerHtmlToScroll,
}: CredentialsProps) => {
  useAutoScrollInstructions(instructionsLink, instructionsInnerHtmlToScroll);

  return (
    <>
      {instructionsLink && (
        <InstructionCallout
          link={instructionsLink}
          innerHtmlToScroll={instructionsInnerHtmlToScroll}
        >
          Open{' '}
          <AppLink
            href={instructionsLink}
            rel="noreferrer"
            target="_blank"
            showInFrame
            innerHtmlToScroll={instructionsInnerHtmlToScroll}
          >
            this guide
          </AppLink>{' '}
          to complete the steps below. Then enter the required values and click
          Continue.
        </InstructionCallout>
      )}
      <StyledInstructionBox>
        <InstructionItem index={1} badgeColor={COLORS.GRAY.GRAY_600}>
          Create a username and email for the Service Account
        </InstructionItem>
        <InstructionItem index={2} badgeColor={COLORS.GRAY.GRAY_600}>
          Assign the Service Account the necessary permissions
        </InstructionItem>
        <InstructionItem index={3} badgeColor={COLORS.GRAY.GRAY_600}>
          Generate the Service Account password
        </InstructionItem>
      </StyledInstructionBox>
      <MainContainer useNewDesign>
        <Input
          value={username.value}
          onChange={(event) => username.onChange(event.target.value)}
          invalid={username.invalid}
          label="Username"
          id="username"
        />
        <PasswordInput
          value={password.value}
          onChange={(event) => password.onChange(event.target.value)}
          invalid={password.invalid}
        />
      </MainContainer>
    </>
  );
};

export default Credentials;
